(function () {
  if (customElements.get('ce-product-inventory-quantity') !== undefined) {
    return;
  }

  class ProductInventoryQuantity extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        product: 'ce-product',
        json: '[data-product-inventory-quantity-json]',
      };

      this.elements = null;
      this.json = null;

      this.handleProductVariantId = this.handleProductVariantId.bind(this);
    }

    get variantId() {
      return this.getAttribute('variant-id');
    }

    set variantId(value) {
      this.setAttribute('variant-id', value);
    }

    static get observedAttributes() {
      return ['variant-id'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'variant-id':
          if (newValue !== null) {
            const variant = this.json.variants[newValue];

            const html = `
              ${variant.inventoryManagement !== null && variant.inventoryPolicy == 'deny' && !variant.isMaximumLimitReached ? `
                <div class="mx-auto ${this.getAttribute('alignment') === 'left' ? 'text-left' : 'text-center'}">
                  <div class="bg-background-alt inline-flex items-center ${this.getAttribute('alignment') === 'left' ? 'justify-start' : 'justify-center'} mx-auto px-3 py-1">
                    ${variant.available ? `
                      <svg viewBox="0 0 20 20" width="16" height="16">
                        <use href="#icon-warning-${Themu.settings.iconStyle}"></use>
                      </svg>
                      <p class="pl-3">
                        ${variant.t.limitedInventory}
                      </p>
                    ` : `
                      <svg viewBox="0 0 20 20" width="16" height="16">
                        <use href="#icon-danger-${Themu.settings.iconStyle}"></use>
                      </svg>
                      <p class="pl-3">
                        ${this.json.t.noInventory}
                      </p>
                    `}
                  </div>
                </div>
                ${variant.incoming ? `
                  <p class="mt-2 ${this.getAttribute('alignment') === 'left' ? 'text-left' : 'text-center'} text-sm">
                    ${variant.t.nextIncomingDate}
                  </p>
                ` : ''}
              ` : ''}
            `;

            this.innerHTML = html;
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        product: this.closest(this.selectors.product),
        json: this.querySelector(this.selectors.json),
      };

      this.json = JSON.parse(this.elements.json.textContent);
      this.elements.json.remove();

      this.elements.product.addEventListener('ce-product:variant-id', this.handleProductVariantId);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.product.removeEventListener('ce-product:variant-id', this.handleProductVariantId);
    }

    handleProductVariantId(event) {
      this.variantId = event.detail;
    }
  }

  customElements.define('ce-product-inventory-quantity', ProductInventoryQuantity);
})();
